import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useLocation } from "react-router-dom";
import { Nav, Navbar, Button, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons'
import HeaderNavBar3 from 'Components/Navigation/TopNavigation/HeaderNavBar3';
import SearchButton from './SearchButton';
import { TextButton } from 'Components/Button';
//import NotificationsOutlined from '@mui/icons-material/NotificationsOutlined';
import ProfileMenu from './ProfileMenu';
import { HashLink } from 'react-router-hash-link';
import TopNavigationListItem3 from 'Components/Navigation/TopNavigation/TopNavigationListItem3';
import { PATHS } from 'Utils/PagePaths';
import logoIcon from 'Images/public/header/PSOPPC-logo.png';
import { Link } from 'react-router-dom';
import NavBar from 'Components/Navigation/Navigation/Top/NavBar';

const Header3 = ({ showCollapsedSideNav, topRef }) => {

  const loginInfo = useSelector(state => state.loginInfo);
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [fadeClass] = useState("fade-out");

  const handleSignInRedirect = () => {
    navigate(
      PATHS.public['Sign In']
    );
  }

  return (
    <>
      {/**skip to main */}
      <header tabIndex={0} id="mainheader" className="header header2" ref={topRef}>
        <div className="hiddenFocusable">
          <HashLink tabIndex={0} to={location.pathname} state={location.state} className={"visually-hidden-focusable text-button btn btn-normal"} fadeClass={fadeClass} elementId="mainContent">
            Skip to main content
          </HashLink>
        </div>
      </header>
      {/**top nav */}
      <Navbar expand="md" id="website-header-nav" className="website-header justify-content-between justify-content-md-center ">
        {/* <Col md={12} className="d-flex flex-column align-items-center"> */}
        <Col md={12} className="d-flex flex-column align-items-center">
          {/** top nav first horizontal line */}
          <Col md={12} className="d-flex justify-content-between align-items-start">
            {/**logo */}
            <Navbar.Brand as={Link} to={PATHS.public.Homepage} className="me-0 ">
              <div className="d-flex flex-row align-items-center gap-1" title="Home">
                <img src={logoIcon} alt="PSOPPC Logo" height="62"></img>
                <span className="body semibold text-white text-start lh-1">PSO Privacy<br></br>Protection Center</span>
              </div>
            </Navbar.Brand>
            <div className="d-none d-lg-flex flex-grow-0 flex-column align-items-end flex-lg-row">
              <div className="d-flex  gap-4  align-items-center">

                <TopNavigationListItem3 classNames="p-0 bodyS semilight" key={"topRespNav7"} listItemTitle={"News & Updates"} listItemLink={PATHS.public['News & Updates']} ></TopNavigationListItem3>
                <TopNavigationListItem3 classNames="p-0 bodyS semilight" key={"topRespNav5"} listItemTitle={"Get Help"} listItemLink={PATHS.public['Get Help']} ></TopNavigationListItem3>
                <TopNavigationListItem3 classNames="p-0 bodyS semilight" key={"topRespNav6"} listItemTitle={"About PSOPPC"} listItemLink={PATHS.public['About PSOPPC']} ></TopNavigationListItem3>
                {
                  loginInfo.token !== "" && !pathname.includes(PATHS.public['Sign In'])
                    ?
                    <TopNavigationListItem3 classNames="p-0 bodyS semilight" key={"topRespNav7"} listItemTitle={"Dashboard"} listItemLink={PATHS.private.dashboard} ></TopNavigationListItem3>
                    :
                    null
                }
              </div>
              <div className="d-md-flex d-md-none gap-4 justify-content-end align-items-center mt-1">
                {
                  pathname.includes(PATHS.public.Search)
                    ? null
                    : <SearchButton isSearchOpen={isSearchOpen} setIsSearchOpen={setIsSearchOpen}></SearchButton>
                }
                {
                  loginInfo.token !== "" && !pathname.includes(PATHS.public['Sign In'])
                    ?
                    <>
                      {/* comment out notification bell for MVP release
                        <IconButton id="notificationButton" className="me-4" icon={() => <NotificationsOutlined style={{ "backgroundColor": "#071E31", "color": "white" }}></NotificationsOutlined>} />
                      */}
                      <ProfileMenu></ProfileMenu>
                    </>
                    :
                    <TextButton
                      className="pt-2 pb-2 ps-3 pe-3"
                      variant="normal"
                      onClick={handleSignInRedirect}
                      content={"Sign In"}
                    >
                    </TextButton>
                }
              </div>
            </div>
          </Col>
          {/** top nav second horizontal line */}
          <Col md={12} className="d-none d-lg-flex flex-row justify-content-between">
            {/**top nav items */}
            
              <NavBar></NavBar>
           
            {/**user info */}
            <div className="d-md-none d-lg-flex gap-4 justify-content-end">
              {
                pathname.includes(PATHS.public.Search)
                  ? null
                  : <SearchButton isSearchOpen={isSearchOpen} setIsSearchOpen={setIsSearchOpen}></SearchButton>
              }
              {
                loginInfo.token !== "" && !pathname.includes(PATHS.public['Sign In'])
                  ?
                  <>
                    {/* comment out notification bell for MVP release
                      <IconButton id="notificationButton" className="me-4" icon={() => <NotificationsOutlined style={{ "backgroundColor": "#071E31", "color": "white" }}></NotificationsOutlined>} />
                    */}
                    <ProfileMenu></ProfileMenu>
                  </>
                  :
                  <TextButton
                    className="pt-2 pb-2 ps-3 pe-3"
                    variant="normal"
                    onClick={handleSignInRedirect}
                    content={"Sign In"}
                  >
                  </TextButton>
              }
            </div>
          </Col>
        </Col>
        {/**hamburger menu when md */}
        <div className="d-lg-none p-2">
          <Button className="collapsedSideNavMenuButton" onClick={showCollapsedSideNav}>
            <FontAwesomeIcon title="Expand Menu Button" icon={faBars} size="lg" />
          </Button>
        </div>
      </Navbar >
      {/**TODO: display search */}
      <Row className='p-0 m-0 text-end pb-3 website-header-nav-mobile-search d-lg-none' style={{ marginTop: "-50px" }}>
        <Col className='pe-3'>
          {
            pathname.includes(PATHS.public.Search)
              ? null
              : <SearchButton isSearchOpen={true} setIsSearchOpen={setIsSearchOpen}></SearchButton>
          }
        </Col>
      </Row>
    </>
  )
}

export default Header3;